export const TIMEKEEPING_REASON_CONSTANTS = {
  MIN_CHARACTERS: 60,
  MAX_CHARACTERS: 500,
} as const;
